import { render, staticRenderFns } from "./ComplainList.vue?vue&type=template&id=204624d5&scoped=true&"
import script from "./ComplainList.vue?vue&type=script&lang=js&"
export * from "./ComplainList.vue?vue&type=script&lang=js&"
import style0 from "./ComplainList.vue?vue&type=style&index=0&id=204624d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../education/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204624d5",
  null
  
)

export default component.exports